import { render, staticRenderFns } from "./DigitalHumanCareer.vue?vue&type=template&id=c46d752c&scoped=true&"
import script from "./DigitalHumanCareer.vue?vue&type=script&lang=ts&"
export * from "./DigitalHumanCareer.vue?vue&type=script&lang=ts&"
import style0 from "./DigitalHumanCareer.vue?vue&type=style&index=0&id=c46d752c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46d752c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
